import { applyMiddleware, createStore, combineReducers } from 'redux';
import logger from 'redux-logger';
import searchReducer from './search/reducer';
import user from './user/reducer';
import detail from './detail/reducer';
import category from './category/reducer';

const rootReducer = combineReducers({
  search: searchReducer,
  user,
  detail,
  category,
});

const store = createStore(rootReducer, applyMiddleware(logger));

export type StoreType = ReturnType<typeof rootReducer>;

export default store;
